import moment from "moment-jalaali";
export function convertToTimestamp(normalDate) {
    const jalaliMoment = moment(normalDate, 'jYYYY/jM/jD----hh:mm:ss a');
    const timestamp = jalaliMoment.valueOf();
  
    return timestamp/1000;
}